export default __webpack_public_path__ + "static/media/camera.0c9d429c.svg";